<template>
	<div class="text-center">
	    <v-menu  :close-on-content-click="false" v-model="menu">
	      	<template v-slot:activator="{ on: menu, attrs }">
	        	<v-tooltip bottom>
	         		<template v-slot:activator="{ on: tooltip }">
			            <v-btn
			              dark
			            	:x-small="isXSmall"
			            	:small="isSmall"
			            	:icon="isIcon"
			              	:color="colorField || 'transparent'"
			              	v-bind="attrs"
			              	v-on="{ ...tooltip, ...menu }"
			              	:fab="isFab" 
			              	:block="isBlock"	              	
			            >
			            	<v-badge
						        dot
						    	left						    							    	
						    	bottom
						        overlap
						        bordered
						        :color="renderSelecteds.length == 2 ? 'green' : 'secondary'"						        
						        offset-x="5"
						        offset-y="10"					
						    >						        
	              				<v-icon x-smal>mdi-calendar</v-icon>
	              			</v-badge>
	              			<v-input  height="2" v-show="isLabel" :messages="renderSelecteds.join(',')" class="custom-message-size">
	              				<span style="font-size: 10px"> {{ $ml.get('date')}} </span>
					        </v-input>
	            		</v-btn>
	          		</template>
	          		<span>{{$ml.get("date") }} : {{renderSelecteds}}</span>
	        	</v-tooltip>
	      	</template>
	      	<v-list>	      		
	        	<v-list-item :key="reference+'Dates'">
	          		<v-list-item-title class="pt-2">
	          			<MenuDate :inputField="inputField" :keyField="keyFieldDates" :isRange="true" placeholder="select_dates" text="select_dates" class="mt-2"></MenuDate>
	          		</v-list-item-title>
	        	</v-list-item>
	        	<v-list-item :key="reference+'Time1'">
	          		<v-list-item-title class="pt-2">
	          			<MenuTime :inputField="inputField" keyField="start" text="start_time" :reference="reference+'start'"></MenuTime>
	          		</v-list-item-title>
	        	</v-list-item>
	          	<v-list-item :key="reference+'Time2'">
	          		<v-list-item-title class="pt-2">
	          			<MenuTime :inputField="inputField" keyField="end" text="end_time" :reference="reference+'end'"></MenuTime>
	          		</v-list-item-title>
	          	</v-list-item>
	          		<v-list-item :key="reference+'confirmTimes'">
	          		<v-list-item-title class="pt-2  d-flex justify-center">
	          			<v-btn x-small color="primary" @click="confirmDateTime()" >
	          				{{ $ml.get('confirm')}}
	          			</v-btn>
	          		</v-list-item-title>
	          	</v-list-item>

	      	</v-list>
	    </v-menu>
  	</div>

</template>
<!-- <style  scoped>
.custom-message-size >>>.v-messages__message {
  font-size: 8px !important; /* Ajusta el tamaño del mensaje */
}
</style> -->
<script type="text/javascript">
	import MenuDate from "@/components/info/MenuDate.vue"
	import MenuTime from "@/components/info/MenuTime.vue"
	export default{
		name : "MenuDateTimes",
		props : ["inputField", "keyFieldDates", "isLabel", "isXSmall", "isSmall", "isFab", "isIcon", "colorField", "isMultiple", "reference", "isBlock"],
		components: { MenuDate, MenuTime },
		data : ()=>({
			loading:false,
			menu:false,	

		}),
		computed:{			
			renderSelecteds(){
				return this.inputField[this.keyFieldDates].length ? this.inputField[this.keyFieldDates].map((x,idx)=>{
					if (this.inputField.start && idx==0) {
						x = x + ' ' + this.inputField.start;
					}else
					if (this.inputField.end && idx==1) {
						x = x + ' ' + this.inputField.end
					}
					return x 
				}) :  [this.$ml.get("none_selected")] 
			}
		},	
		methods:{
			confirmDateTime(){
				this.menu=false;
				this.$emit("receiveConfirm", true);
			}
		}
	}
</script>